<template>
  <div class="panel">
    <div class="title">表单自动推送<a-button class="title-btn" type="primary" @click="pushFormEdit">设置</a-button></div>
    <a-table class='info' :columns='columns' :loading="loading" :dataSource='dataSource' :pagination='false'  rowKey='id' size='small'>
      <span slot="formList" slot-scope="text,record">
        <template v-for="(form,index) in record.formList">
          <a-tag style='text-align: center;width: 80px' v-if="form.push==='1'" :key="index">
            <a-tooltip >
              <template slot="title">
                {{form.formName}}
              </template>
              <div class="one-row">
                {{form.formName}}
              </div>
            </a-tooltip>
          </a-tag>
        </template>
      </span>
    </a-table>
    <PushFormModel ref="pushFormModel" @ok="loadData" ></PushFormModel>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  import PushFormModel from './modal/PushFormModel'
  export default {
    name: 'FormPushSet',
    components: { PushFormModel },
    props:{
      projectId:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        dataSource:[],
        loading:false,
        columns:[
          {
            title: '周期序号',
            width:100,
            align:'center',
            customRender: (text, record, index) => `V${index+1}`
          },
          {
            title: '周期名称',
            width:200,
            dataIndex: 'name',
            align:'center',
            ellipsis: true,
          },
          {
            title: '自动推送表单',
            scopedSlots: {customRender: 'formList'},
            ellipsis: true,
          }
        ]
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        this.loading = true
        getAction('/project/projectPeriodItem/listAndItem',{projectId:this.projectId,base:'0',halfway:'0'}).then(res=>{
          if(res.success){
            this.dataSource = res.result
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      /**
       * 表单自动推送
       */
      pushFormEdit() {
        this.$refs['pushFormModel'].edit(this.dataSource)
      },
    },
  }
</script>

<style scoped>

</style>